const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {    
        dataField: 'question',
        text: 'Question',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {    
        dataField: 'categoryName',
        text: 'Category',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    }
];
    
export const sorting = [{
    dataField: 'createdOn',
    order: 'desc'
}];